import { clearStorage, getStorage, setStorage } from '@getjust/commons';
import { z } from 'zod';

export const EMAIL_CHECK_CACHE_SCHEMA_VERSION = 1;

export const ZEmailCheckOutcome = z.enum(['existing', 'new']);
export type EmailCheckOutcome = z.infer<typeof ZEmailCheckOutcome>;

export const ZEmailCheckCache = z.object({
  schemaVersion: z.literal(EMAIL_CHECK_CACHE_SCHEMA_VERSION),
  email: z.string(),
  outcome: ZEmailCheckOutcome,
  validatedAt: z.number(),
});

export type EmailCheckCache = z.infer<typeof ZEmailCheckCache>;

const cacheKey = (shopId: string) => `just_email_check_${shopId}`;

export function readEmailCheck(shopId: string): EmailCheckCache | null {
  if (!shopId) return null;
  const raw = getStorage<unknown>('localStorage', cacheKey(shopId));
  if (!raw) return null;
  const parsed = ZEmailCheckCache.safeParse(raw);
  if (!parsed.success) {
    // Schema drift or corruption — drop and cold-path.
    clearStorage('localStorage', cacheKey(shopId));
    return null;
  }
  return parsed.data;
}

export function writeEmailCheck(
  shopId: string,
  email: string,
  outcome: EmailCheckOutcome,
): void {
  if (!shopId || !email) return;
  const payload: EmailCheckCache = {
    schemaVersion: EMAIL_CHECK_CACHE_SCHEMA_VERSION,
    email,
    outcome,
    validatedAt: Date.now(),
  };
  setStorage('localStorage', cacheKey(shopId), payload);
}

export function clearEmailCheck(shopId: string): void {
  if (!shopId) return;
  clearStorage('localStorage', cacheKey(shopId));
}
